﻿import { Utils } from "./utils";

export class TouchUtils {
    private static touchDataKeys = {
        captured: "touch-utils-captured",
        moved: "touch-utils-moved"
    };

    // simulate a mouse event based on a touch event
    public static simulateMouseEvent(
        touchEvent: TouchEvent,
        mouseEventType: "click" | "dblclick" | "mousedown" | "mouseenter" | "mouseleave" | "mousemove" | "mouseout" | "mouseover" | "mouseup"
    ) {
        // ignore multi-touch events
        if (touchEvent.touches.length > 1) {
            return;
        }

        // do not simulate mouse events for inputs, textareas, selects
        // this allows native behavior (focus, input) to work
        const target = touchEvent.target as HTMLElement;
        const tagName = target.tagName.toUpperCase();
        if (tagName === "INPUT" || tagName === "TEXTAREA" || tagName === "SELECT" || tagName === "OPTION") {
            return;
        }

        touchEvent.preventDefault();

        let touch = touchEvent.changedTouches[0];

        // set the touch coordinates
        let mouseEvent = new MouseEvent(
            mouseEventType,
            {
                screenX: touch.screenX,
                screenY: touch.screenY,
                clientX: touch.clientX,
                clientY: touch.clientY,
                button: 0,
                cancelable: true,
                bubbles: true,
                view: window,
                detail: 1
            }
        );

        touchEvent.target.dispatchEvent(mouseEvent);
    }

    // fire simulated mouse events from touch input
    public static addMouseSimulation(element: JQuery) {
        // validate that touch is supported by browser
        if ("ontouchend" in document) {
            element.on("touchstart", this.touchStart);
            element.on("touchmove", this.touchMove);
            element.on("touchend", this.touchEnd);

            element.data(this.touchDataKeys.captured, false);
            element.data(this.touchDataKeys.moved, false);
        }
    }

    public static removeMouseSimulation(element: JQuery) {
        element.off("touchstart", this.touchStart);
        element.off("touchmove", this.touchMove);
        element.off("touchend", this.touchEnd);

        element.removeData(this.touchDataKeys.captured);
        element.removeData(this.touchDataKeys.moved);
    }

    private static touchStart(event: JQuery.TouchStartEvent) {
        let element = $(this);
        let _this = TouchUtils;

        if (element.data(_this.touchDataKeys.captured)) {
            return;
        }

        element.data(_this.touchDataKeys.captured, true);
        element.data(_this.touchDataKeys.moved, false);

        _this.simulateMouseEvent(event.originalEvent, 'mouseover');
        _this.simulateMouseEvent(event.originalEvent, 'mousemove');
        _this.simulateMouseEvent(event.originalEvent, 'mousedown');
    }

    private static touchMove(event: JQuery.TouchMoveEvent) {
        let element = $(this);
        let _this = TouchUtils;

        if (!element.data(_this.touchDataKeys.captured)) {
            return;
        }

        element.data(_this.touchDataKeys.moved, true);

        _this.simulateMouseEvent(event.originalEvent, 'mousemove');
    }

    private static touchEnd(event: JQuery.TouchEndEvent) {
        let element = $(this);
        let _this = TouchUtils;

        if (!element.data(_this.touchDataKeys.captured)) {
            return;
        }

        _this.simulateMouseEvent(event.originalEvent, 'mouseup');
        _this.simulateMouseEvent(event.originalEvent, 'mouseout');

        if (!element.data(_this.touchDataKeys.moved)) {
            _this.simulateMouseEvent(event.originalEvent, 'click');
        }

        element.data(_this.touchDataKeys.captured, false);
    }
}